custom.CartTerms = (function () {
  var selectors = {
    overlay: 'overlay',
    wrapper: 'wrapper',
    content: 'content',
    btnDeny: 'deny',
    btnAccept: 'accept',
  };

  function CartTerms() {
    this.nodes = {
      overlay: document.querySelector(`.terms-${selectors.overlay}`),
      wrapper: document.querySelector(`.terms-${selectors.wrapper}`),
      content: document.querySelector(`.terms-${selectors.content}-${selectors.wrapper}`),
      btnDeny: document.querySelector(`.terms-${selectors.btnDeny}`),
      btnAccept: document.querySelector(`.terms-${selectors.btnAccept}`),
    };

    this.init();
  }

  CartTerms.prototype = Object.assign({}, CartTerms.prototype, {
    init: function () {
      [this.nodes.overlay, this.nodes.btnDeny].forEach((el) => {
        el.addEventListener('click', this.hideTerms.bind(this));
      });

      this.nodes.btnAccept.addEventListener('click', () => {
        window.location = '/checkout';
      });

      var observer = new MutationObserver(() => {
        var isOpen = !!document.documentElement.classList.contains('js-drawer-open');
        var isActive = !!this.nodes.overlay.classList.contains(`terms-${selectors.overlay}--active`);
        if (!isOpen && isActive) {
          this.hideTerms();
        }
      });
      observer.observe(document.documentElement, { attributes: true });
    },

    showTerms: function () {
      this.nodes.overlay.classList.add(`terms-${selectors.overlay}--active`);
      this.nodes.wrapper.classList.add(`terms-${selectors.wrapper}--active`);
      this.nodes.content.classList.add(`terms-${selectors.content}-${selectors.wrapper}--active`);
    },

    hideTerms: function () {
      this.nodes.overlay.classList.remove(`terms-${selectors.overlay}--active`);
      this.nodes.wrapper.classList.remove(`terms-${selectors.wrapper}--active`);
      this.nodes.content.classList.remove(`terms-${selectors.content}-${selectors.wrapper}--active`);
    },
  });

  return CartTerms;
})();
